import { LOGIN } from "../types";

const initialState = {
  profile: {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    countryCode: "",
    twoFactorAuth: false,
    isSuperStatus: 0,
    roleId: [],
    userId: "",
    companyAccountantName: null,
  },
  isAuthenticated: false,
  token: "",
};

const loginReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case LOGIN.REQUEST:
      return {
        ...state,
        profile: {},
        isAuthenticated: false,
      };
    case LOGIN.SUCCESS:
      return {
        ...state,
        profile: {
          ...action.payload.user,
        },
        isAuthenticated: true,
        token: action.payload.token,
      };
    case LOGIN.UPDATE:
      return {
        ...state,
        profile: {
          ...state.profile, // 👈 keep existing fields
          ...action.payload.user, // 👈 overwrite only what changed
          // companyAccountantName:action.payload.user.companyAccountantName
        },
      };
    default:
      return state;
  }
};

export default loginReducer;
